<template>
  <div>
    <v-container v-if="currentView == 'A'">
      <v-col offset-md="3" :md="6">
        <div v-if="createTour"><h1 class="text-center primary--text mb-n3">Create New Tournament</h1></div>
        <div v-else><h1 class="text-center primary--text mb-n3">Edit Tournament</h1></div>
        <v-col offset-md="4" :md="4">
          <v-switch v-model="createTour" ref="new" label="Create New" @change="createChange"></v-switch>
        </v-col>
        <div v-if="!createTour">
          <v-select v-model="tourId" class="mt-n4" @change="tourChange"
            :items="ownTourList" item-text="tournamentName" item-value="tournamentId"
            label="Choose Tournament">
          </v-select>
        </div>
        <div v-if="createTour || tourId != 0">
          <v-form>
            <v-text-field v-model="tourName" label="Tournament Name" 
              ref="tourName" @change="entryChanged=true" />
            <v-textarea rows="1" auto-grow v-model="tourDesc" ref="tourDesc"
              label="Tournament Description" @change="entryChanged=true" />
            <v-select v-model="sportId"
              :items="sportList" item-text="sportName" item-value="sportId" ref="sportId"
              label="Choose Sport" @change="entryChanged=true" >
            </v-select>
            <v-select v-model="tourType" :items="tourTypeList" ref="tourType"
              label="Tournament Type" @change="entryChanged=true" >
            </v-select>
            <v-select v-model="tourGameType" :items="tourGameTypeList" ref="gameType"
              label="Tournament Game Type" @change="entryChanged=true" >
            </v-select>
            <!--<v-text-field v-if="tourType !== 'L'" v-model="numGroups" type="number" label="Number of Groups" />-->
            <v-select v-if="tourType !== 'L'" v-model="koStartLevel"
              :items="koList" @change="koStartLevelChange" ref="koStartLevel"
              label="Knockout Start Level" >
            </v-select>
            <v-radio-group v-model="tourVisibility" row label="Tour Visibility" @change="entryChanged=true" >
              <v-radio label="Public" value="P" ref="tourVisibility"></v-radio>
              <v-radio label="Private" value="V"></v-radio>
            </v-radio-group>
            <v-text-field type="date" v-model="startDate" ref="startDate" @change="entryChanged=true" label="Start Date" />
            <v-text-field type="date" v-model="endDate" ref="endDate" @change="entryChanged=true" label="End Date" />
            
            <v-card class="mx-auto mb-2" width="400" v-if="tourType !== 'L' && koStartLevel > 0">
              <h2 class="text-center primary--text design-1">Knockout Points</h2>
              <h5 class="text-center primary--text design-1">Update the points for each correct guess at each level</h5>
              <div class="ml-16 mr-16" v-for="koPoints in koPointsList" :key="koPoints.koValue">
                <v-text-field type="number" @change="oddsChanged=true" v-model="koPoints.koPoints" :label="koPoints.koName" />
              </div>
            </v-card>
            <v-divider></v-divider>
            <v-row class="mt-2">
              <v-btn color="success" outlined to="/">
                <v-icon>mdi-close</v-icon>
                Cancel
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" outlined @click="tourNext">
                Next
                <v-icon>mdi-skip-next</v-icon>
              </v-btn>
            </v-row>
          </v-form>
        </div>
      </v-col>
    </v-container>
    <v-container v-if="currentView == 'B' && tourId!=0">
      <v-col offset-md="3" :md="6">
        <TourGroup :tourId="tourId" :gameType="tourGameType" :tourName="tourName" @message="currentView='A'" />
      </v-col>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import TourGroup from '@/components/TourGroup.vue'

export default {
  name: 'tournament',
  components: { TourGroup },
  computed: {
    ...mapGetters([
      'ownTourList',
      'sportList',
      'tourFields',
      'tourFields', 'tourFieldsLoaded',
      'knockoutOdds', 'knockoutOddsLoaded'
    ]),
    koList: function() {
      let koNumbers = [2, 4, 8, 16, 32, 64, 128, 256]
      let koNames = ['Final', 'Semi-Final', 'Quarter-Final', 'Best of 16', 'Best of 32', 'Best of 64',
                    'Best of 128', 'Best of 256']
      var temp = []
      var i=0
      for (i=0; i<8; i++) {
        let ko = {
          value: koNumbers[i],
          text: koNames[i]
        }
        temp.push(ko)
      }
      return temp;
    }
  },
  data: () => ({
    createTour: false,
    tourId: 0,
    sportId: '',
    tourName: '',
    tourDesc: '',
    tourTypeList: [],
    tourGameTypeList: [],
    tourType: '',
    tourGameType: '',
    koStartLevel: 0,
    numGroups: 1,
    tourVisibility: '',
    startDate: '',
    endDate: '',
    koPointsList: [],
    currentView: 'A',
    entryChanged: false,
    oddsChanged: false,
  }),
  created() {
    this.$store.dispatch('getOwnTourList')
    this.$store.dispatch('getSportList')
    this.tourTypeList[0] = { text: "League Only", value: "L" }
    this.tourTypeList[1] = { text: "Knockout Only", value: "K" }
    this.tourTypeList[2] = { text: "League followed by Knockout", value: "B" }
    this.tourGameTypeList[0] = { text: "Indivual Game", value: "I" }
    this.tourGameTypeList[1] = { text: "Team Game", value: "T" }
  },
  watch: {
    tourFieldsLoaded: function() {
      if (this.tourFields.tournamentName) {
        this.tourName = this.tourFields.tournamentName
        this.tourDesc = this.tourFields.tournamentDesc
        this.sportId = this.tourFields.sportId
        this.tourType = this.tourFields.tournamentType
        this.tourGameType = this.tourFields.tournamentGameType
        this.numGroups = this.tourFields.numGroups
        this.koStartLevel = this.tourFields.knockoutStartLevel
        this.tourVisibility = this.tourFields.tourVisibility
        this.startDate = this.tourFields.startDate.substring(0, 10)
        this.endDate = this.tourFields.endDate.substring(0, 10)
      }
    },
    knockoutOddsLoaded: function() {
      this.popKOPointsList()
    }
  },
  methods: { 
    popKOPointsList() {
      let numbers = [1, 2, 4, 8, 16, 32, 64, 128, 256]
      let names = ['Winner', 'Final', 'Semi-Final', 'Quarter-Final', 'Best of 16', 'Best of 32', 'Best of 64',
                    'Best of 128', 'Best of 256']
      var i = 0
      if (this.tourId !== 0 && this.knockoutOdds && this.knockoutOdds.length > 0) {
        this.koPointsList.splice(0)
        if (this.koStartLevel > 0) {
          for (i = Math.log2(this.koStartLevel); i>=0; i--) {
            let ko = { koValue: numbers[i], koName: names[i] }
            let ind = this.knockoutOdds.findIndex(elem => elem.koLevel === numbers[i] )
            ko.koPoints = (ind >= 0) ? this.knockoutOdds[ind].odds : 0
            this.koPointsList.push(ko)
          }
        }
      } else {
        this.koPointsList.splice(0)
        if (this.koStartLevel > 0) {
          for (i = Math.log2(this.koStartLevel); i>=0; i--) {
            let ko = { koValue: numbers[i], koName: names[i], koPoints: 0 }
            this.koPointsList.push(ko)
          }
        }
      }
    },
    createChange() {
      if (this.createTour) {
        this.tourId = 0
        this.tourName = ''
        this.tourDesc = ''
        this.sportId = ''
        this.tourType = ''
        this.tourGameType = ''
        this.koStartLevel = 0
        this.tourVisibility = ''
        this.startDate = ''
        this.endDate = ''
      }
    },
    tourChange() {
      this.$store.dispatch('getTourFields', this.tourId)
      this.$store.dispatch('getKnockoutOdds', this.tourId)
    },
    koStartLevelChange() {
      this.popKOPointsList()
      this.entryChanged = true
    },
    tourNext() {
      this.saveTour()
      this.currentView = 'B'
    },
    checkFields() {
      this.tourName.trim()
      if (this.tourName == '') {
        alert("Enter Tournament Name")
        this.$refs.tourName.focus()
        return false
      }
      this.tourDesc.trim()
      if (this.tourDesc === '') {
        alert("Enter Tournament Desc")
        this.$refs.tourDesc.focus()
        return false
      }
      if (!this.sportId) {
        alert("Choose a Sport")
        this.$refs.sportId.focus()
        return false
      }
      if (this.tourType === '') {
        alert("Chosee a Tournament Type")
        this.$refs.tourType.focus()
        return false
      }
      if (this.tourGameType === '') {
        alert("Choose a Game Type")
        this.$refs.gameType.focus()
        return false
      }
      if ((this.tourType === 'B' || this.tourType === 'K') && this.koStartLevel === 0) {
        alert("Choose the Knockout Start level")
        this.$refs.koStartLevel.focus()
        return false
      }
      if (this.tourVisibility === '') {
        alert("Choose Tournament Visibility")
        this.$refs.tourVisibility.focus()
        return false
      }
      if (this.startDate === '') {
        alert("Enter the Start Date")
        this.$refs.startDate.focus()
        return false
      }
      if (this.endDate === '') {
        alert("Enter the End Date")
        this.$refs.endDate.focus()
        return false
      }
      return true
    },
    saveTour() {
      if (!this.entryChanged && !this.oddsChanged) {
        return
      }
      if (!this.checkFields()) {
        return
      }
      const token = this.$store.getters.authToken
      var tourData = {
        tournamentName: this.tourName,
        tournamentDesc: this.tourDesc,
        tournamentType: this.tourType,
        tournamentGameType: this.tourGameType,
        numGroups: this.numGroups,
        knockoutStartLevel: this.koStartLevel,
        sportId: this.sportId,
        tourVisibility: this.tourVisibility,
        startDate: this.startDate,
        endDate: this.endDate
      }
      if (this.tourId !== 0) {
        tourData.tournamentId = this.tourId
      }
      if (token) {
        const header = { 'Content-Type': 'application/json', 'x-auth': token }
        axios.post('/api/tournament', JSON.stringify(tourData), { headers: header })
        .then(response => {
          if (this.tourId === 0) {
            this.tourId = response.data
          }
          this.entryChanged = false
          this.saveKOPoints()
        })
        .catch(err => {
          alert(err.response.data.err)
        })
      }
    },
    saveKOPoints() {
      if (!this.oddsChanged) {
        return
      }
      var i = 0
      for (i=0; i<this.koPointsList.length; i++) {
        let ko = {
          tournamentId: this.tourId,
          koLevel: this.koPointsList[i].koValue,
          odds: Number(this.koPointsList[i].koPoints)
        }
        const token = this.$store.getters.authToken
        if (token) {
          const header = { 'Content-Type': 'application/json', 'x-auth': token }
          axios.post('/api/knockoutOdd', JSON.stringify(ko), { headers: header })
          .then(() => {
            this.oddsChanged = false
          })
          .catch(err => {
            alert(err.response.data.err)
          })
        }
      }
    },
  }
}
</script>